import React from "react";
import "./Persona.scss";
import quill from "../../images/quill.svg";

const Persona = () => {
  return (
    <div className="Persona">
      <h1>
        Dr. Dattatreya Tapkeer <img src={quill} className="quill"></img>
      </h1>
      <h2>A glance towards journey so far</h2>
      <div className="bio">
        <p>
          <i className="left-quote fas fa-quote-left fa-2x"></i>
          Dolores, aliquam corrupti maxime quas consequatur enim cum? Maiores exercitationem doloremque dolorum esse itaque natus, aperiam facere qui quam debitis. Id, quae! Eum optio deserunt impedit debitis voluptatum. 
          <i className="right-quote fas fa-quote-right fa-2x"></i>
        </p>
      </div>
    </div>
  );
};

export default Persona;
